import React from 'react'

import { Code } from './Component.client'

export type CodeBlockProps = {
  code: string
  language?: string | null
  blockType: 'code'
}

type Props = CodeBlockProps & {
  className?: string
}

export function CodeBlock({ className, code, language }: Props) {
  return (
    <div className={[className, 'my-[20px] text-light', 'not-prose'].filter(Boolean).join(' ')}>
      <Code code={code} language={language ?? undefined} />
    </div>
  )
}
